import {ADDRESS_FIELDS} from '../../separate-fields/address-fields-checkbox-group';

export const addressFieldNames = [
    ADDRESS_FIELDS.CITY,
    ADDRESS_FIELDS.STATE,
    ADDRESS_FIELDS.POSTAL_CODE,
] as const;

export const dropdownFieldNames = [ADDRESS_FIELDS.COUNTRY, ADDRESS_FIELDS.STATE] as const;
